export function getFileName(dataUrl) {
  const fileName = dataUrl.split('/').pop()
  return fileName
}
